import { createDictionaryApiFactory, mapDictionaryState } from "./dictionaryApiFactory";

export const mapToImprovementPlanFinalizeReason = mapDictionaryState;

const improvementPlanOriginApi = createDictionaryApiFactory("improvementPlanFinalizeReasons");

export const getImprovementPlanFinalizeReason = improvementPlanOriginApi.search;